var n = /* @__PURE__ */ ((N) => (N.CONNECTED = "connected", N.DISCONNECTED = "disconnected", N.PENDING = "pending", N))(n || {});
export {
  n as AppleCompanyState
};
